import { inject } from '@angular/core';
import { CanMatchFn, UrlSegment } from '@angular/router';
import { AuthService } from '../../../core/services/auth/auth.service';

/** Whether a `shipments/…` URL lands on a page that shows the map (the list or a shipment's details). */
export function showsShipmentsMap(segments: readonly UrlSegment[]): boolean {
  const [, page, sub] = segments.map(segment => segment.path);
  return page === undefined || page === 'list' || sub === 'details';
}

/**
 * LBRD-6255: the HERE map is a `@defer` chunk. Left to the `@defer` block alone, its download
 * would only start once the shipments module had loaded and the page had rendered — a waterfall
 * the eager import never had. Matching the `shipments` route starts it instead, in parallel with
 * the module itself, but only for URLs that show a map and only for a signed-in user: the
 * create / edit / redirect pages, and the login redirect, still never fetch HERE.
 *
 * Never blocks: it always matches. The `@defer` blocks resolve to the same chunk, so they pick
 * up the in-flight (or finished) request.
 */
export const prefetchShipmentsMap: CanMatchFn = (_route, segments) => {
  if (inject(AuthService).isLoggedIn && showsShipmentsMap(segments)) {
    void import('../base/shipments-map/shipments-map.component').catch(() => undefined);
  }
  return true;
};
